import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from '@sentry/remix'
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from '@remix-run/react'
import { startTransition, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'

init({
  dsn: 'https://237df4ac229fcfc7f8d424e22388e26a@o4509689162891264.ingest.us.sentry.io/4509689164464128',
  tracesSampleRate: 1,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  enabled: import.meta.env.PROD,
})

startTransition(() => {
  hydrateRoot(
    document,
    // <StrictMode>
    <RemixBrowser />,
    // </StrictMode>,
  )
})
